import img0 from "./img_0.png";
import img1 from "./img_1.png";
import img2 from "./img_2.png";
import img3 from "./img_3.png";
import img4 from "./img_4.png";
import img5 from "./img_5.png";
import img6 from "./img_6.png";
import img7 from "./img_7.png";
import img8 from "./img_8.png";
import img9 from "./img_9.png";
import img10 from "./img_10.png";
import img11 from "./img_11.png";
import img12 from "./img_12.png";
import img13 from "./img_13.png";
import img14 from "./img_14.png";
import img15 from "./img_15.png";
import img16 from "./img_16.png";
import img17 from "./img_17.png";
import img18 from "./img_18.png";

const uxAnimation = {
  v: "5.5.9",
  fr: 29.9700012207031,
  ip: 0,
  op: 180.00000733155,
  w: 230,
  h: 450,
  nm: "UX Design Animation",
  ddd: 0,
  assets: [
    { id: "image_0", w: 512, h: 512, u: "", p: img0, e: 0 },
    { id: "image_1", w: 49, h: 49, u: "", p: img1, e: 0 },
    { id: "image_2", w: 49, h: 49, u: "", p: img2, e: 0 },
    { id: "image_3", w: 84, h: 12, u: "", p: img3, e: 0 },
    { id: "image_4", w: 92, h: 25, u: "", p: img4, e: 0 },
    { id: "image_5", w: 57, h: 57, u: "", p: img5, e: 0 },
    { id: "image_6", w: 30, h: 12, u: "", p: img6, e: 0 },
    { id: "image_7", w: 114, h: 17, u: "", p: img7, e: 0 },
    { id: "image_8", w: 17, h: 17, u: "", p: img8, e: 0 },
    { id: "image_9", w: 125, h: 17, u: "", p: img9, e: 0 },
    { id: "image_10", w: 27, h: 12, u: "", p: img10, e: 0 },
    { id: "image_11", w: 17, h: 13, u: "", p: img11, e: 0 },
    { id: "image_12", w: 114, h: 17, u: "", p: img12, e: 0 },
    { id: "image_13", w: 89, h: 12, u: "", p: img13, e: 0 },
    { id: "image_14", w: 17, h: 17, u: "", p: img14, e: 0 },
    { id: "image_15", w: 114, h: 17, u: "", p: img15, e: 0 },
    { id: "image_16", w: 49, h: 12, u: "", p: img16, e: 0 },
    { id: "image_17", w: 17, h: 16, u: "", p: img17, e: 0 },
    { id: "image_18", w: 375, h: 667, u: "", p: img18, e: 0 },
    {
      id: "comp_0",
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 2,
          nm: "Edit Button",
          refId: "image_1",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 165,
                  s: [100]
                },
                { t: 180.00000733155, s: [0] }
              ],
              ix: 11
            },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [288.5, 120.5, 0], ix: 2 },
            a: { a: 0, k: [24.5, 24.5, 0], ix: 1 },
            s: {
              a: 1,
              k: [
                {
                  i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                  o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                  t: 0,
                  s: [0, 0, 100]
                },
                { t: 30.0000012219251, s: [100, 100, 100] }
              ],
              ix: 6
            }
          },
          ao: 0,
          ip: 0,
          op: 241.000009816131,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 2,
          ty: 2,
          nm: "Settings Button",
          refId: "image_2",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 165,
                  s: [100]
                },
                { t: 180.00000733155, s: [0] }
              ],
              ix: 11
            },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [88.5, 120.5, 0], ix: 2 },
            a: { a: 0, k: [24.5, 24.5, 0], ix: 1 },
            s: {
              a: 1,
              k: [
                {
                  i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.833] },
                  o: { x: [0.167, 0.167, 0.167], y: [0.167, 0.167, 0.167] },
                  t: 0,
                  s: [0, 0, 100]
                },
                { t: 30.0000012219251, s: [100, 100, 100] }
              ],
              ix: 6
            }
          },
          ao: 0,
          ip: 0,
          op: 241.000009816131,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 3,
          ty: 2,
          nm: "Location",
          refId: "image_3",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 165,
                  s: [100]
                },
                { t: 180.00000733155, s: [0] }
              ],
              ix: 11
            },
            r: { a: 0, k: 0, ix: 10 },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 30,
                  s: [-59.491, 198.833, 0],
                  to: [41.333, 0, 0],
                  ti: [-41.333, 0, 0]
                },
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 60,
                  s: [188.509, 198.833, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0]
                },
                { t: 150.000006109625, s: [188.509, 198.833, 0] }
              ],
              ix: 2
            },
            a: { a: 0, k: [41.692, 5.914, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          ip: 0,
          op: 241.000009816131,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 4,
          ty: 2,
          nm: "Name",
          refId: "image_4",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 165,
                  s: [100]
                },
                { t: 180.00000733155, s: [0] }
              ],
              ix: 11
            },
            r: { a: 0, k: 0, ix: 10 },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 30,
                  s: [433.5, 177.686, 0],
                  to: [-40.833, 0, 0],
                  ti: [40.833, 0, 0]
                },
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 60,
                  s: [188.5, 177.686, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0]
                },
                { t: 150.000006109625, s: [188.5, 177.686, 0] }
              ],
              ix: 2
            },
            a: { a: 0, k: [45.557, 12.344, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          ip: 0,
          op: 241.000009816131,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 5,
          ty: 2,
          nm: "Profile Icon",
          refId: "image_5",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 165,
                  s: [100]
                },
                { t: 180.00000733155, s: [0] }
              ],
              ix: 11
            },
            r: { a: 0, k: 0, ix: 10 },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 0,
                  s: [188.5, -37.5, 0],
                  to: [0, 26.333, 0],
                  ti: [0, -26.333, 0]
                },
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 30,
                  s: [188.5, 120.5, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0]
                },
                { t: 150.000006109625, s: [188.5, 120.5, 0] }
              ],
              ix: 2
            },
            a: { a: 0, k: [28.25, 28.25, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          ip: 0,
          op: 241.000009816131,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 6,
          ty: 2,
          nm: "Mobile",
          refId: "image_6",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 60,
                  s: [0]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 75,
                  s: [100]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 165,
                  s: [100]
                },
                { t: 180.00000733155, s: [0] }
              ],
              ix: 11
            },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [87.229, 319.833, 0], ix: 2 },
            a: { a: 0, k: [14.729, 5.914, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          ip: 0,
          op: 241.000009816131,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 7,
          ty: 2,
          nm: "Mobile Phone Number",
          refId: "image_7",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 60,
                  s: [0]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 75,
                  s: [100]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 165,
                  s: [100]
                },
                { t: 180.00000733155, s: [0] }
              ],
              ix: 11
            },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [129.139, 302.766, 0], ix: 2 },
            a: { a: 0, k: [56.639, 8.28, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          ip: 0,
          op: 241.000009816131,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 8,
          ty: 2,
          nm: "Mobile Icon",
          refId: "image_8",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 60,
                  s: [0]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 75,
                  s: [100]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 165,
                  s: [100]
                },
                { t: 180.00000733155, s: [0] }
              ],
              ix: 11
            },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [40.477, 309.521, 0], ix: 2 },
            a: { a: 0, k: [8.274, 8.271, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          ip: 0,
          op: 241.000009816131,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 9,
          ty: 2,
          nm: "Email",
          refId: "image_9",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 75,
                  s: [0]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 90,
                  s: [100]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 165,
                  s: [100]
                },
                { t: 180.00000733155, s: [0] }
              ],
              ix: 11
            },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [134.147, 382.766, 0], ix: 2 },
            a: { a: 0, k: [62.289, 8.28, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          ip: 0,
          op: 241.000009816131,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 10,
          ty: 2,
          nm: "Home",
          refId: "image_10",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 75,
                  s: [0]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 90,
                  s: [100]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 165,
                  s: [100]
                },
                { t: 180.00000733155, s: [0] }
              ],
              ix: 11
            },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [85.837, 399.833, 0], ix: 2 },
            a: { a: 0, k: [13.337, 5.914, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          ip: 0,
          op: 241.000009816131,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 11,
          ty: 2,
          nm: "Email Icon",
          refId: "image_11",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 75,
                  s: [0]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 90,
                  s: [100]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 165,
                  s: [100]
                },
                { t: 180.00000733155, s: [0] }
              ],
              ix: 11
            },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [40.5, 389.5, 0], ix: 2 },
            a: { a: 0, k: [8.25, 6.25, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          ip: 0,
          op: 241.000009816131,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 12,
          ty: 2,
          nm: "XD Message Number",
          refId: "image_12",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 90,
                  s: [0]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 105,
                  s: [100]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 165,
                  s: [100]
                },
                { t: 180.00000733155, s: [0] }
              ],
              ix: 11
            },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [129.139, 462.766, 0], ix: 2 },
            a: { a: 0, k: [56.639, 8.28, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          ip: 0,
          op: 241.000009816131,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 13,
          ty: 2,
          nm: "XD Message",
          refId: "image_13",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 90,
                  s: [0]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 105,
                  s: [100]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 165,
                  s: [100]
                },
                { t: 180.00000733155, s: [0] }
              ],
              ix: 11
            },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [116.962, 479.833, 0], ix: 2 },
            a: { a: 0, k: [44.478, 5.914, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          ip: 0,
          op: 241.000009816131,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 14,
          ty: 2,
          nm: "XD Message Icon",
          refId: "image_14",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 90,
                  s: [0]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 105,
                  s: [100]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 165,
                  s: [100]
                },
                { t: 180.00000733155, s: [0] }
              ],
              ix: 11
            },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [40.502, 469.5, 0], ix: 2 },
            a: { a: 0, k: [8.279, 8.277, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          ip: 0,
          op: 241.000009816131,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 15,
          ty: 2,
          nm: "Phone Number 2",
          refId: "image_15",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 105,
                  s: [0]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 120,
                  s: [100]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 165,
                  s: [100]
                },
                { t: 180.00000733155, s: [0] }
              ],
              ix: 11
            },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [129.139, 542.766, 0], ix: 2 },
            a: { a: 0, k: [56.639, 8.28, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          ip: 0,
          op: 241.000009816131,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 16,
          ty: 2,
          nm: "Whats App",
          refId: "image_16",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 105,
                  s: [0]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 120,
                  s: [100]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 165,
                  s: [100]
                },
                { t: 180.00000733155, s: [0] }
              ],
              ix: 11
            },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [96.679, 559.833, 0], ix: 2 },
            a: { a: 0, k: [24.179, 5.914, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          ip: 0,
          op: 241.000009816131,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 17,
          ty: 2,
          nm: "Whats App Icon",
          refId: "image_17",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 105,
                  s: [0]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 120,
                  s: [100]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 165,
                  s: [100]
                },
                { t: 180.00000733155, s: [0] }
              ],
              ix: 11
            },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [40.486, 549.224, 0], ix: 2 },
            a: { a: 0, k: [8.263, 7.974, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          ip: 0,
          op: 241.000009816131,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 18,
          ty: 2,
          nm: "Dividers",
          refId: "image_18",
          sr: 1,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 0,
                  s: [0]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 125,
                  s: [0]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 135,
                  s: [100]
                },
                {
                  i: { x: [0.833], y: [0.833] },
                  o: { x: [0.167], y: [0.167] },
                  t: 165,
                  s: [100]
                },
                { t: 180.00000733155, s: [0] }
              ],
              ix: 11
            },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [187.75, 333.75, 0], ix: 2 },
            a: { a: 0, k: [187.5, 333.5, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          ip: 0,
          op: 241.000009816131,
          st: 0,
          bm: 0
        }
      ]
    }
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 2,
      nm: "phone.ai",
      cl: "ai",
      refId: "image_0",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [115, 225, 0], ix: 2 },
        a: { a: 0, k: [256, 256, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      ip: 0,
      op: 180.00000733155,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 2,
      ty: 0,
      nm: "Phone Screen Breakdown",
      refId: "comp_0",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [115, 209, 0], ix: 2 },
        a: { a: 0, k: [187.5, 333.5, 0], ix: 1 },
        s: { a: 0, k: [49, 49, 100], ix: 6 }
      },
      ao: 0,
      w: 375,
      h: 667,
      ip: 0,
      op: 180.00000733155,
      st: 0,
      bm: 0
    }
  ],
  markers: []
};

export default uxAnimation;